import { H3, Text } from '@betterment/samba-react';

import { SambaAutoLink } from '~/b4b/components/SambaAutoLink';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

export const ForfeitureFund: React.FC = () => {
  return (
    <>
      <Text as="p" css={{ pb: 'space.200' }}>
        Forfeiture funds are accrued in two main ways:
      </Text>

      <ol>
        <li>
          <Text as="p">
            When auto-enrolled participants request their money back in accordance with the eligible automatic
            contribution arrangement (EACA), any associated employer contributions is added to your forfeiture fund.
          </Text>
          Connect your payroll provider.
        </li>
        <li>
          <Text as="p">
            When terminated participants either take a distribution or have a 5-year break in service, any unvested
            employer contributions they had is added to your forfeiture fund.
          </Text>
        </li>
      </ol>

      <Text as="p" css={{ pb: 'space.200' }}>
        If you want to see when and why forfeiture funds were generated, you can run a{' '}
        <SambaAutoLink to={urlBuilder.reportsNew({ report: 'forfeiture_account' })}>
          forfeiture fund report
        </SambaAutoLink>
        . You can learn more about forfeiture funds in our{' '}
        <SambaAutoLink target="_blank" rel="noopener noreferrer" to={urlBuilder.getUnallocatedFundsGuide()}>
          Guide to unallocated funds
        </SambaAutoLink>
        .
      </Text>

      <H3 variant="title100">Your forfeiture funds can be used in the following ways:</H3>

      <ul>
        <li>
          <Text as="p">To offset future employer matching contributions or profit sharing contributions.</Text>
        </li>
        <li>
          <Text as="p">
            To pay eligible plan fees and expenses such as auditing, accounting, recordkeeping and annual administration
            & compliance services.
          </Text>
        </li>
        <li>
          <Text as="p">To reallocate to eligible participants as additional employer contributions.</Text>
        </li>
      </ul>

      <Text as="p" css={{ pb: 'space.200' }}>
        If the{' '}
        <SambaAutoLink to={urlBuilder.unallocatedFundsAutomationEdit()}>
          Auto apply unallocated funds setting
        </SambaAutoLink>{' '}
        is on, we'll apply these funds to your payroll automatically. You can also contact support to use the funds in
        any of the other was listed above.
      </Text>

      <H3 variant="title100">Timing requirements</H3>

      <Text as="p">
        Forfeiture funds typically need to be used by the end of the year after the year the forfeiture way accrued.
      </Text>
    </>
  );
};
